import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function ProtectedRoute({ children, roles }) {
	const { user, loading } = useAuth();
	const location = useLocation();

	if (loading || user === undefined) {
		return (
			<div className="min-h-screen grid place-items-center">
				<div className="flex items-center gap-3 text-slate-500">
					<div className="w-3 h-3 rounded-full bg-emerald-500 animate-pulse-soft" />
					Loading…
				</div>
			</div>
		);
	}
	if (!user) {
		return <Navigate to="/login" replace state={{ from: location }} />;
	}
	if (roles && roles.length > 0 && !roles.includes(user.role)) {
		return <Navigate to="/dashboard" replace />;
	}
	return children;
}
